import gql from "graphql-tag";

export const SAVE_ITEM_FROM_PAVING_MODULE = gql`
  mutation saveItemFromPavingModule($where: AddItemFromPavingModuleInput!) {
    saveItemFromPavingModule(where: $where)
  }
`;